import type { PathStep } from "./path-builder"

export const findElementFromPath = (
	path: Array<PathStep | string>,
): HTMLElement | null => {
	let node: HTMLElement | null = document.body

	for (let i = 1; i < path.length; i++) {
		const step = path[i] as PathStep
		let index = 0

		for (const childNode of Array.from(node.children)) {
			if (childNode.nodeName === step.name) {
				index++
			}

			if (
				index === step.index &&
				childNode.id === step.id &&
				childNode.className === step.class &&
				childNode.textContent?.startsWith(step.text ?? "")
			) {
				node = childNode as HTMLElement
				break
			}
		}
	}

	return node
}
